import { makeSocialPostLengthCounter } from 'utils/string';

export const TWITTER_MAX_DESCRIPTION_CHARS = 280;
export const TWITTER_LINK_LENGTH = 23;
export const TWITTER_DESCRIPTION_LENGTH_COUNTER = makeSocialPostLengthCounter(
  TWITTER_LINK_LENGTH,
);
